const mainSkills = [
  'HTML & CSS',
  'Pug & Sass',
  'Bootstrap',
  'TailwindCSS',
  'JavaScript (ES6)',
  'Vue',
  'Angular',
  'Node.js',
  'PHP',
  'Laravel',
  'MySQL',
  'Web Services',
];

const secondarySkills = [
  'Figma',
  'SCRUM',
  'Git',
  'Firebase',
  'DigitalOcean',
  'NPM',
  'Eslint',
  'Github',
];

export { mainSkills, secondarySkills };
